import React, { useState, useContext, useEffect } from 'react';

import PropTypes from 'prop-types';

import './VettingCreditCheck.css';

import {
  SalesContext
} from "./../../../Context/SalesContext";

import VettingCheckBoxPanel from '../../Common/VettingCheckBoxPanel/VettingCheckBoxPanel';

import {
  checkInputValidity,
  getKeyValueData,
  createArray
} from '../../../Utility/utility';
import {
  tagOnCreditConsentCheck1,
  tagOnCreditConsentCheck2
} from "../../../Tagging/NewCustomerTagging";

const VettingCreditCheck = (props) => {
  const context = useContext(SalesContext);
  const creditCheckDetails = context.vettingCreditDetails.creditCheckDetails;

  const [formData, setFormData] = useState({
    // Form Fields
    formComponents: {
      acceptInformation: {
        name: "I give consent to Vodacom (PTY) Ltd to perform a credit check on this application.",
        type: "checkbox",
        value: creditCheckDetails?.acceptInformation?.value || false,
        width: 100,
        validations: {
          type: "input",
          required: true,
          invalidMessage: "",
        },
        config: {
          type: "input",
          required: true,
          tabIndex: "3"
        },
        isValid: false,
        isTouched: true
      },
      giveConsent: {
        name: "I agree that my information above is correct and accurate",
        type: "checkbox",
        value: creditCheckDetails?.giveConsent?.value || false,
        width: 100,
        validations: {
          type: "input",
          required: true,
          invalidMessage: "",
        },
        config: {
          type: "input",
          required: true,
          tabIndex: "3"
        },
        isValid: false,
        isTouched: true
      }
    },
    isFormValid:false
  });

  // Create array
  const formCompArray = createArray(formData.formComponents);

  const formComponentChangeHandler = (event, inputIdentifier) => {
    if (inputIdentifier == "acceptInformation" && event){
      tagOnCreditConsentCheck1();
    } 
    if (inputIdentifier == "giveConsent" && event) {
      tagOnCreditConsentCheck2();
    } 
    const formCompsCopy = { ...formData.formComponents };
    const changedComponent = { ...formCompsCopy[inputIdentifier] };
    changedComponent.value = event;

    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    changedComponent.isTouched = true;

    const newFormComps = {
      ...formCompsCopy,
      [inputIdentifier]: changedComponent
    }

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });

    
  };

  useEffect(()=>{
    saveDetails();
  }, [formData])

  const saveDetails = () => {
    const keyValueData = getKeyValueData(formData.formComponents);
    for (let key in keyValueData){
      if(!keyValueData[key].value){
        props.onNextClick(null);
        return;
      }
    }
    context.setVettingDetails('creditCheckDetails', keyValueData);
    props.onNextClick(keyValueData);
  }

  return (
    <div className="vetting-credit-check-wrapper">
      {
        formCompArray.map(item => {
          return (
            <VettingCheckBoxPanel
              value={item.config.value}
              label={item.config.name}
              inputIdentifier={item.key}
              key={item.key}
              onChange={formComponentChangeHandler}
            />
          )
        })
      }
    </div>
  )
}

VettingCreditCheck.propTypes = {
  onNextClick: PropTypes.func,
}

export default VettingCreditCheck;